<template>
    <section class="container mx-auto py-12 px-4">
        <!-- Page Title -->
        <div class="text-center mb-12">
            <h2 class="text-4xl font-bold text-green-900 mb-4">Upcoming Events</h2>
            <p class="text-lg text-gray-600">
                Explore our latest events and join us to create unforgettable memories.
            </p>
        </div>

        <!-- Event Cards -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div v-for="event in events" :key="event.slug" class="bg-white shadow-lg rounded-lg overflow-hidden">
                <!-- Event Image -->
                <div class="relative w-full h-0" style="padding-top: 56.25%;">
                    <router-link :to="{ name: 'EventSinglePage', params: { slug: event.slug } }">
                        <img :src="`${this.$root.$data.BASE_URL}/event/${event.image}`" :alt="event.title"
                            class="absolute inset-0 w-full h-full object-cover" />
                    </router-link>
                </div>
                <!-- Event Details -->
                <router-link :to="{ name: 'EventSinglePage', params: { slug: event.slug } }">
                    <div class="p-6">
                        <h3 class="text-xl font-bold text-gray-800 mb-2">
                            {{ event.title }}
                        </h3>
                        <p class="text-sm text-gray-600 mb-4 line-clamp-2">
                            {{ event.description }}
                            <a href="#" class="text-blue-500 font-medium">...read more</a>
                        </p>
                        <div class="flex items-center text-sm text-gray-500">
                            <i class="far fa-clock mr-2"></i>
                            <span>{{ event.start_date }}</span>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";

export default {
    name: "EventsPage",
    data() {
        return {
            events: [], // Holds the events fetched from the API
        };
    },
    methods: {
        async fetchEvents() {
            try {
                const BASE_URL = this.$root.$data.BASE_URL;
                const response = await axios.get(`${BASE_URL}/api/event/list`);
                this.events = response.data.map((event) => ({
                    ...event,
                    imageUrl: `${BASE_URL}/event/${event.image}`, // Build the image URL
                }));
            } catch (error) {
                console.error("Error fetching events:", error);
            }
        },
    },
    created() {
        this.fetchEvents(); // Fetch events when the component is created
    },
};
</script>

<style scoped>
/* Optional: Clamp lines for description */
.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>